import { Navigate } from "react-router-dom";
import { Box, Paper, Stack, Typography } from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { useNewEmailVerification } from "./hooks/useNewEmailVerification";
import { CircularProgress, Logo } from "../../components";

const NewEmailVerification = () => {
  const { status, timerCount, isValidParams } = useNewEmailVerification();

  if (!isValidParams) {
    return <Navigate to="/" replace />;
  }

  return (
    <Stack height="100dvh" justifyContent="center" alignItems="center">
      <Paper elevation={3}>
        <Box px={2} pt={4} pb={3} width={{ xs: 340, sm: 400 }}>
          <Stack alignItems="center" mb={3}>
            <Logo width={170} />
          </Stack>
          {status === "pending" && (
            <>
              <Typography variant="h2" textAlign="center" mb={0.5}>
                We are verifying your new email
              </Typography>
              <Typography variant="body1" textAlign="center" mb={2}>
                Please don't leave this page
              </Typography>
            </>
          )}
          {status === "success" && (
            <>
              <Typography variant="h2" textAlign="center" mb={0.5}>
                Email verification succeeded
              </Typography>
              <Typography variant="body1" textAlign="center" mb={2}>
                You can now use your new email to log in
              </Typography>
            </>
          )}
          {status === "error" && (
            <>
              <Typography variant="h2" textAlign="center" mb={0.5}>
                Email verification failed
              </Typography>
              <Typography variant="body1" textAlign="center" mb={2}>
                Please try again later or contact support
              </Typography>
            </>
          )}
          <Stack alignItems="center">
            {status === "pending" && <CircularProgress size="lg" />}
            {status === "success" && (
              <>
                <TaskAltIcon color="success" fontSize="large" />
                <Typography variant="body1" textAlign="center" mt={2}>
                  This page will close up automatically in {timerCount}
                </Typography>
              </>
            )}
            {status === "error" && (
              <>
                <WarningAmberIcon color="error" fontSize="large" />
                <Typography variant="body1" textAlign="center" mt={2}>
                  This page will close up automatically in {timerCount}
                </Typography>
              </>
            )}
          </Stack>
        </Box>
      </Paper>
    </Stack>
  );
};

export default NewEmailVerification;
